import { CardChoice, GameEvent, GameMode } from "../engine/types";
import { ComputerPlayer, HumanPlayer } from "../engine/players";
import { LocalGame } from "../engine/rules";
import { EventListener, Transport } from "./transport";

export interface LocalRunnerOpts {
  randomSeed: number;
  mode: GameMode;
  humanName?: string;
}

export class LocalRunner implements Transport {
  spectate = false;
  human: HumanPlayer;
  private game: LocalGame;
  private listeners = new Set<EventListener>();
  private stopped = false;

  constructor(opts: LocalRunnerOpts) {
    this.human = new HumanPlayer(opts.humanName ?? "You");
    const players: [HumanPlayer, ComputerPlayer, ComputerPlayer, ComputerPlayer] = [
      this.human,
      new ComputerPlayer("Sammy"),
      new ComputerPlayer("Waz"),
      new ComputerPlayer("Riles"),
    ];
    this.game = new LocalGame(players, opts.randomSeed || 1, opts.mode);
  }

  start(): void {
    this.loop();
  }

  stop(): void {
    this.stopped = true;
  }

  onEvent(l: EventListener): () => void {
    this.listeners.add(l);
    return () => this.listeners.delete(l);
  }

  send(_choice: CardChoice): void {
    // The local runner gets choices via human.submitPlay/submitPose directly.
  }

  private async loop(): Promise<void> {
    while (!this.stopped) {
      const ev = await this.game.advanceGameIteration();
      const broadcast = this.maskOpponentHands(ev);
      this.listeners.forEach((l) => l(broadcast));
      if (ev.eventType === "gameWin") return;
      const tickMs = this.tickFor(ev);
      if (tickMs > 0) await delay(tickMs);
    }
  }

  private tickFor(ev: GameEvent): number {
    switch (ev.eventType) {
      case "playerTurn":
        return 50;
      case "playedCard":
      case "posedCard":
      case "passed":
        return 350;
      case "roundBlocked":
      case "roundDraw":
      case "roundInvalid":
      case "roundWin":
        return 1500;
      case "gameWin":
        return 0;
      default:
        return 30;
    }
  }

  private maskOpponentHands(ev: GameEvent): GameEvent {
    return {
      ...ev,
      playerHands: [
        ev.playerHands[0],
        ev.playerHands[1].map(() => 29),
        ev.playerHands[2].map(() => 29),
        ev.playerHands[3].map(() => 29),
      ],
    };
  }
}

function delay(ms: number): Promise<void> {
  return new Promise((r) => setTimeout(r, ms));
}
